import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';

import ResponsiveGridLayout from '../../../../components/ResponsiveGridLayout';
import styles from './styles.scss';

export const INITIAL_MAX_LOCATIONS = 18;

/**
 * A list of restaurant locations with links.
 */
export default class LocationList extends React.Component {
  state = {
    hasMounted: false,
    isExpanded: false,
  };

  /**
   * Allow us to set CSS properties for some elements only after the page has
   * initially mounted.
   */
  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  onClickViewAll = () => {
    this.setState({ isExpanded: true });
  };

  render() {
    const { heading, viewAllButtonLabel, children } = this.props;
    const { hasMounted, isExpanded } = this.state;

    const showViewAll = hasMounted && !isExpanded && children.length > INITIAL_MAX_LOCATIONS;
    const maxVisibleLocations = isExpanded ? children.length : INITIAL_MAX_LOCATIONS;

    const viewAll = (
      <div className={styles.viewAll}>
        <Button type="secondary" size="small" onClick={this.onClickViewAll}>
          {viewAllButtonLabel}
        </Button>
      </div>
    );

    return (
      <div id="choose-location">
        <Spacer spacing="x-large 0">
          <Heading
            level={2}
            size="x-small"
            spacing={{ mobile: '0 0 medium 0', tablet: '0 0 x-large 0' }}
          >
            <span className={styles.heading}>{heading}</span>
          </Heading>
          <ResponsiveGridLayout gutter="medium" maxColumns={3} minColumnWidth={160}>
            {React.Children.map(children, (child, index) => {
              const isHidden = hasMounted && index > maxVisibleLocations;
              return (
                <div
                  key={`location-${child.props.url}`}
                  className={classnames({ [styles.hidden]: isHidden })}
                >
                  {child}
                </div>
              );
            })}
          </ResponsiveGridLayout>
          {showViewAll && viewAll}
        </Spacer>
      </div>
    );
  }
}

LocationList.propTypes = {
  /**
   * A heading for the list of brand locations
   */
  heading: PropTypes.string.isRequired,

  /**
   * Label for the ‘view all’ button
   */
  viewAllButtonLabel: PropTypes.string.isRequired,

  /**
   * A set of children to render, in place of the list of menu items, to allow
   * landing pages to explicitly define the set of child menu items rendered.
   */
  children: PropTypes.node.isRequired,
};
